export function EmptyState({ message = "Data not found" }) {
  return (
    <div className="min-h-[33.25rem] flex flex-col items-center justify-center text-gray-400">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="96"
        height="96"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        style={{ marginBottom: "8px" }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M12 9v3.75M12 15.75h.007M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p className="font-medium">{message}</p>
    </div>
  );
}
